import { Privacy as App } from 'web-pages/pages/Privacy'

const Privacy = () => {
  return <App />
}

export default Privacy
